import api from './config';

const quizService = {
    // Categories
    getCategories: async () => {
        const response = await api.get('/api/categories');
        return response.data.data;
    },

    getCategoryById: async (id) => {
        const response = await api.get(`/api/categories/${id}`);
        return response.data.data;
    },

    // Questions
    getQuiz: async (categoryId) => {
        const response = await api.get(`/api/questions/quiz/${categoryId}`);
        return response.data.data;
    },

    getRandomQuestion: async (categoryId = null, level = null) => {
        let url = '/api/questions/random';
        if (categoryId) {
            url += `/${categoryId}`;
            if (level) {
                url += `/${level}`;
            }
        }
        const response = await api.get(url);
        return response.data.data;
    },

    // Historique
    getHistory: async (userId) => {
        const response = await api.get(`/api/historique/compte/${userId}`);
        return response.data.data;
    },

    getStats: async (userId) => {
        const response = await api.get(`/api/historique/stats/${userId}`);
        return response.data.data;
    },

    recordAnswer: async (userId, questionId, answerId) => {
        const response = await api.post('/api/historique', {
            idCompte: userId,
            idQue: questionId,
            idReponse: answerId,
        });
        return response.data.data;
    },

    recordGame: async (userId, categoryId, score, nbQuestions, heureDebut, heureFin) => {
        const response = await api.post('/api/historique', {
            idCompte: userId,
            idCat: categoryId,
            score,
            nbQuestions,
            heureDebut,
            heureFin,
        });
        return response.data.data;
    },
};

export default quizService;